import { Link } from "react-router-dom";
import { isAdmin } from "../auth/AuthGate";

const C = {
  copper: "#b5836d", dark: "#2d2a26", muted: "#7a756e",
  bg: "#faf8f6", card: "#ffffff", line: "#ebe5df",
};

function OptionCard({ to, icon, title, subtitle }) {
  return (
    <Link to={to} style={{
      display: "block", textDecoration: "none", color: "inherit",
      background: C.card, border: `1px solid ${C.line}`, borderRadius: "16px",
      padding: "36px 28px", textAlign: "center",
      boxShadow: "0 2px 16px rgba(0,0,0,0.05)",
      transition: "transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease",
    }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-4px)";
        e.currentTarget.style.boxShadow = "0 8px 28px rgba(0,0,0,0.1)";
        e.currentTarget.style.borderColor = C.copper;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "0 2px 16px rgba(0,0,0,0.05)";
        e.currentTarget.style.borderColor = C.line;
      }}
    >
      <div style={{ fontSize: "48px", marginBottom: "14px" }}>{icon}</div>
      <div style={{
        fontSize: "20px", fontWeight: 700, color: C.dark,
        fontFamily: "'DM Sans',sans-serif", marginBottom: "6px",
      }}>{title}</div>
      <div style={{
        fontSize: "13px", color: C.muted,
        fontFamily: "'DM Sans',sans-serif",
      }}>{subtitle}</div>
    </Link>
  );
}

export default function Portada({ user, signOut }) {
  const admin = isAdmin(user);

  return (
    <div style={{
      minHeight: "100vh", background: C.bg, padding: "48px 20px",
      display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
      fontFamily: "'Libre Baskerville','Georgia',serif",
    }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Libre+Baskerville:wght@400;700&family=DM+Sans:wght@400;500;600;700&display=swap');`}</style>

      {/* Top-right user */}
      {user && (
        <div style={{
          position: "fixed", top: "12px", right: "12px", display: "flex", gap: "6px", alignItems: "center",
          fontFamily: "'DM Sans',sans-serif", fontSize: "11px",
        }}>
          <span style={{ color: C.muted, background: "#ffffffcc", padding: "4px 10px", borderRadius: "999px", border: `1px solid ${C.line}` }}>
            {user.email}
          </span>
          <button onClick={signOut} style={{
            padding: "4px 10px", borderRadius: "999px", border: `1px solid ${C.line}`,
            background: "#ffffffcc", color: C.muted, cursor: "pointer", fontSize: "11px", fontWeight: 600,
          }}>Salir</button>
        </div>
      )}

      <h1 style={{
        fontSize: "clamp(28px, 5vw, 42px)", color: C.dark, margin: 0,
        letterSpacing: "-0.02em", textAlign: "center",
      }}>Clase</h1>
      <p style={{
        fontSize: "14px", color: C.muted, fontFamily: "'DM Sans',sans-serif",
        margin: "8px 0 40px", textAlign: "center",
      }}>Elegí la herramienta</p>

      <div style={{ width: "100%", maxWidth: "680px", display: "flex", flexDirection: "column", gap: "20px" }}>
        <div style={{ display: "grid", gap: "20px", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))" }}>
          <OptionCard to="/finanzas" icon="💰" title="Clase de Finanzas"
            subtitle="Herramientas interactivas" />
          <OptionCard to="/canvas" icon="🧩" title="Modelo Canvas"
            subtitle="Business Model Canvas" />
        </div>
        <OptionCard to="/preguntas" icon="💬" title="Preguntas"
          subtitle="Consultá al profesor y mirá las respondidas" />
      </div>

      {admin && (
        <Link to="/admin" style={{
          marginTop: "32px", padding: "10px 22px", borderRadius: "10px",
          background: C.dark, color: "#fff", textDecoration: "none",
          fontFamily: "'DM Sans',sans-serif", fontSize: "13px", fontWeight: 700,
          boxShadow: "0 2px 10px rgba(0,0,0,0.12)",
        }}>⚙️ Admin</Link>
      )}
    </div>
  );
}
